/*
 * Filename: form-control-configuration-panel.component.tsx
 * Description: Page section holds fields level configuration information
 */

import React, { Component, ReactNode } from 'react';
import { FieldsConfigInformation } from './fields-config-information.component';
import { LayoutAttibutes } from './layout-attributes.component';
import { AppliedRulesListContainer } from './applied-rules-list.component';
import { ApplyRuleModal } from './apply-rule/template-apply-rule-modal.component';
import { ApplyUIType } from './apply-rule/rule-components/ui-type.componenet';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import { CQAppConstant } from './../../../app-constants';

export class CQFormControlConfiguration
    extends Component<{ selectedTemplateName: string }, { isApplyRuleModalVisible: boolean, objectName?: string, appliedRule?: string, appliedRuleObject?: any }> {
    constructor(props: Readonly<{ selectedTemplateName: string, isLayoutApplicable: boolean }>) {
        super(props);
        this.state = {
            isApplyRuleModalVisible: false,
            objectName: '',
            appliedRule: '',
            appliedRuleObject: {}
        };
    }

    public render(): ReactNode {
        const fieldObj: any = CQMasterDataStore.Details.selectedFieldDetailsObject;
        const selectedObject :any = CQMasterDataStore.OutputConfig.getSelectedObject(this.props.selectedTemplateName);
        const selectedLayout :any = CQMasterDataStore.OutputConfig.getSelectedLayout(this.props.selectedTemplateName);
        return (
            <>
                <div className="slds-col config-sidebar full-height">
                    <div className="bg-white full-height slds-p-around_small scroll-content">
                        <div className="slds-grid slds-grid_vertical">
                            {/* <!-- label value pair for fileds --> */}
                            {
                                !fieldObj.isComponentEventRule &&
                                <FieldsConfigInformation />

                            }
                            {/* <!-- label value pair for fileds --> */}
                            {/* <!-- Attribute From Layout section --> */}
                            {
                                !fieldObj.isComponentEventRule &&
                                <LayoutAttibutes />
                            }
                            {/* <!-- Attribute From Layout section --> */}
                            {/* <!-- form rules section --> */}
                            <AppliedRulesListContainer selectedTemplateName={this.props.selectedTemplateName} toggleModalVisibility={this.toggleModalVisibility} />
                            {/* <!-- form rules section --> */}

                            {
                                !fieldObj.isComponentEventRule &&fieldObj.type === 'Text' &&
                                <>
                                    <ApplyUIType 
                                        selectedTemplateName={this.props.selectedTemplateName} 
                                        selectedObject={selectedObject} 
                                        selectedLayout={selectedLayout}
                                        fieldName={fieldObj.fullName}
                                    />
                                </>
                            }
                            {
                                !fieldObj.isComponentEventRule && this.props.selectedTemplateName===CQAppConstant.CQNBA && 
                                    (fieldObj.type === CQAppConstant.NBA_TYPES.URL || fieldObj.type === CQAppConstant.NBA_TYPES.NOTIFICATION|| fieldObj.type === CQAppConstant.NBA_TYPES.QUICK_ACTION) &&
                                    <>  
                                        <div className="slds-grid slds-grid_align-spread slds-m-vertical_small">
                                            <button disabled={!(fieldObj.label)}
                                                onClick={()=>this.deleteNba(fieldObj.fullName)} 
                                                className="slds-col slds-size_1-of-3 slds-button slds-button_destructive slds-button_medium"
                                                    >Delete</button>
                                        </div>
                                    </>
                            }
                        </div>
                    </div>
                </div>

                {
                    this.state.isApplyRuleModalVisible &&
                    <ApplyRuleModal
                        selectedTemplateName={this.props.selectedTemplateName}
                        toggleModalVisibility={this.toggleModalVisibility}
                        objectName={this.state.objectName}
                        appliedRule={this.state.appliedRule}
                        appliedRuleObject={this.state.appliedRule} />
                }
            </>
        );
    }

    /**
     * @private
     * @memberof CQFormControlConfigurationRootComponent
     */
    private toggleModalVisibility = (objectName?: string, appliedRule?: string, appliedRuleObject?: any) => {
        this.setState({
            isApplyRuleModalVisible: !this.state.isApplyRuleModalVisible,
            objectName,
            appliedRule,
            appliedRuleObject
        });
    }

    /**
     * @private
     * @memberof CQFormControlConfigurationRootComponent
     */
     private deleteNba = (nbaApiName:string) => {
        let quickActionsInStore = CQMasterDataStore.OutputConfig.getQuickActions(CQAppConstant.CQNBA);
        quickActionsInStore = quickActionsInStore.filter((quickAction:any)=>{
            return quickAction.fullName !== nbaApiName
        })
        CQMasterDataStore.OutputConfig.setQuickActions(CQAppConstant.CQNBA, quickActionsInStore);
        CQMasterDataStore.Details.setSelectedFieldDetailsObject({});
        const ruleElements = {...CQMasterDataStore.RuleElements.FieldRuleElement};
        if(ruleElements.hasOwnProperty(nbaApiName)){
            delete ruleElements[nbaApiName];
        }
        CQMasterDataStore.OutputConfig.setRuleElements(CQAppConstant.CQNBA, ruleElements);
        const inputRules = {...CQMasterDataStore.OutputConfig['cqNBA'].inputRules};
        if(inputRules.hasOwnProperty(nbaApiName)){
            delete inputRules[nbaApiName];
        }
        CQMasterDataStore.OutputConfig.setInputRules(CQAppConstant.CQNBA, inputRules);
    }
}

export const CQFormControlConfigurationRootComponent = observer(
    CQFormControlConfiguration
);